import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import ModalWindow from './ModalWindow.react';
var Modal = function Modal(_ref) {
  var windows = _ref.windows,
    hideModalAction = _ref.hideModalAction;
  if (windows.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "fullscreen"
  }, windows.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "overlay overlay__animate",
    onClick: function onClick() {
      return hideModalAction();
    }
  }), windows.map(function (x) {
    return /*#__PURE__*/React.createElement(ModalWindow, {
      onClick: function onClick() {
        return hideModalAction();
      },
      key: x.id
    }, x.component);
  }));
};
var mstp = function mstp(s) {
  return {
    windows: s.modal.windows
  };
};
var mdtp = {
  showModalAction: modalActions.show,
  hideModalAction: modalActions.hide
};
export default connect(mstp, mdtp)(Modal);